import {CALL_API} from '../../middleware/api';

// 待办任务
export const PROCESS_DETAIL_REQUEST = 'PROCESS_DETAIL_REQUEST';
export const PROCESS_DETAIL_SUCCESS = 'PROCESS_DETAIL_SUCCESS';
export const PROCESS_DETAIL_FAILURE = 'PROCESS_DETAIL_FAILURE';

export function getProcessDetail(id) {
	return {
		[CALL_API]: {
			types: [PROCESS_DETAIL_REQUEST, PROCESS_DETAIL_SUCCESS, PROCESS_DETAIL_FAILURE],
			endpoint: '/workflow/process/detail?processInstanceId=' + id,
		}
};
}

export default (id) => {
	return (dispatch, getState) => {
		return dispatch(getProcessDetail(id));
	};
};


// WEBPACK FOOTER //
// ./src/action/workflow/processDetail.js